import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Space,
  Popconfirm,
  message,
  ConfigProvider,
  Tag,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  FontSizeOutlined,
} from "@ant-design/icons";
import "./size.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const SizeVariants = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [form] = Form.useForm();

  const fetchSizes = () => {
    callApi(
      "GET",
      routes.sizeVariant,
      null,
      setLoading,
      (res) => {
        console.log("res of data ", res);
        setData(res?.data?.variantSizes || []);
      },
      (err) => message.error("Failed to fetch sizes")
    );
  };

  useEffect(() => {
    fetchSizes();
  }, []);

  const showModal = (item = null) => {
    setEditingItem(item);
    if (item) {
      form.setFieldsValue(item);
    } else {
      form.resetFields();
    }
    setIsModalOpen(true);
  };

  const handleProcess = (values) => {
    const method = editingItem ? "PATCH" : "POST";
    const url = editingItem
      ? `${routes.sizeVariant}/${editingItem._id}`
      : routes.sizeVariant;

    callApi(
      method,
      url,
      values,
      setLoading,
      () => {
        message.success(
          `Size ${editingItem ? "updated" : "added"} successfully`
        );
        setIsModalOpen(false);
        fetchSizes();
      },
      (err) => message.error("Operation failed")
    );
  };

  const handleDelete = (id) => {
    callApi("DELETE", `${routes.sizeVariant}/${id}`, null, setLoading, () => {
      message.success("Size deleted");
      fetchSizes();
    });
  };

  const columns = [
    {
      title: "Size Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (active) => (
        <Tag color={active ? "orange" : "default"} className="active-tag">
          {active ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <EditOutlined
            className="edit-action"
            style={{ color: "#FFA450", cursor: "pointer" }}
            onClick={() => showModal(record)}
          />
          <Popconfirm
            title="Delete this size?"
            onConfirm={() => handleDelete(record._id)}
          >
            <DeleteOutlined className="delete-action" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#FFA450" } }}>
      <div className="user-table-container">
        <div className="variant-header">
          <h2>Size Variants</h2>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => showModal()}
          >
            Add New Size
          </Button>
        </div>

        <Table
          dataSource={data}
          columns={columns}
          rowKey="_id"
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />

        <Modal
          title={editingItem ? "Edit Size Variant" : "Add Size Variant"}
          open={isModalOpen}
          onOk={() => form.submit()}
          onCancel={() => setIsModalOpen(false)}
          confirmLoading={loading}
          okText={editingItem ? "Update" : "Add"}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleProcess}
            initialValues={{ isActive: true }}
          >
            <Form.Item
              name="name"
              label="Size Name (e.g. Small, Large, 42)"
              rules={[{ required: true, message: "Please enter size name" }]}
            >
              <Input placeholder="Enter size name" />
            </Form.Item>
            <Form.Item name="isActive" label="Status" valuePropName="checked">
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </ConfigProvider>
  );
};

export default SizeVariants;
